import { LoaderBlockUI } from "src/components/loader";
import { useTypedSelector } from "src/hooks/useTypedSelector";

function LoaderManager() {
    const { loading, message } = useTypedSelector((state) => state.loading);

    return (
        <>
            {
                loading &&
                <LoaderBlockUI message={message} />
            }
        </>
    );
}

export default LoaderManager;